import { render, staticRenderFns } from "./loaderLotus.vue?vue&type=template&id=2fa1d168"
import script from "./loaderLotus.vue?vue&type=script&lang=js"
export * from "./loaderLotus.vue?vue&type=script&lang=js"
import style0 from "./loaderLotus.vue?vue&type=style&index=0&id=2fa1d168&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports